module.exports = __webpack_public_path__ + "img/farzana-christopher-46.6ed6dec7.jpg";